import CollapsibleSection from '@boViews/shared/CollapsibleSection';
import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import Action from '@sharedComponents/Action';
import Button from '@sharedComponents/Button';
import Table from '@sharedComponents/Table';
import Typography from '@sharedComponents/Typography';
import { displayText, parseI18n } from '@src/i18n';
import { useTranslation } from 'react-i18next';

import rowStyle from '@sharedComponents/Row/style.module.css';

/**
 * Section listing, in a table like the list of the collections, the collections that hold the test, `collections`
 * being `{ id, name }` with the name an i18n JSON string. `onOpen(collection)` opens the page of a collection, from
 * its name or its pencil.
 */
const CollectionsSection = ({ collections = [], onOpen = () => {} }) => {
    const { t } = useTranslation('bo');

    const columns = [
        {
            key: 'name',
            label: t('Name'),
            pinned: true,
            fill: true,
            tdClassName: rowStyle.td,
            render: (collection) => (
                <Action action={() => onOpen(collection)} tabIndex={0} role="link">
                    <Typography span fontWeight="medium">
                        {displayText(parseI18n(collection.name)) || `#${collection.id}`}
                    </Typography>
                </Action>
            ),
        },
        {
            key: 'actions',
            ariaLabel: t('Actions'),
            pinned: true,
            tdClassName: rowStyle.tdActions,
            render: (collection) => <Button ghost icon={faPenToSquare} title={t('Edit')} action={() => onOpen(collection)} />,
        },
    ];

    return (
        <CollapsibleSection title={t('Collections ({{total}})', { total: collections.length })}>
            {collections.length === 0 ? (
                <Typography color="neutral-secondary">{t('This test is in no collection.')}</Typography>
            ) : (
                <Table columns={columns} items={collections} getRowKey={(collection) => collection.id} />
            )}
        </CollapsibleSection>
    );
};

export default CollectionsSection;
